module.exports = __webpack_public_path__ + "img/one.f76850a4.png";